import { PARAMS } from "@src/common/constants";
import { ChatPermission, WhiteboardPermission } from "@src/gql/graphql";
import { getPublicWebAppOrigin } from "@src/utils/app-url";
import { parseChatDocumentId } from "../collaboration/document-id";

export function chatPermissionToWhiteboardPermission(
	permission: ChatPermission,
): WhiteboardPermission {
	if (permission === ChatPermission.Write) {
		return WhiteboardPermission.Write;
	}
	if (permission === ChatPermission.Owner) {
		return WhiteboardPermission.Owner;
	}
	return WhiteboardPermission.Read;
}

export function whiteboardPermissionToChatPermission(
	permission: WhiteboardPermission,
): ChatPermission {
	return permission === WhiteboardPermission.Write
		? ChatPermission.Write
		: ChatPermission.Read;
}

export function getChatShareLink(chatId: string, shareKey?: string | null) {
	const typedChatId = parseChatDocumentId(chatId).toString();
	const shareKeyParam = shareKey ? `?${PARAMS.shareKey}=${shareKey}` : "";
	return `${getPublicWebAppOrigin()}/${typedChatId}${shareKeyParam}`;
}
